export const cibAsana = ["32 32","<path d='M25.042 16.87c-3.844 0-6.964 3.115-6.964 6.958 0 3.849 3.12 6.964 6.964 6.964 3.839 0 6.958-3.12 6.958-6.964 0-3.839-3.115-6.958-6.958-6.958zM6.958 16.87c-3.839 0-6.958 3.115-6.958 6.958 0 3.849 3.12 6.964 6.958 6.964 3.844 0 6.964-3.12 6.964-6.964 0-3.839-3.115-6.958-6.964-6.958zM22.958 8.172c0 3.844-3.115 6.958-6.958 6.958s-6.958-3.115-6.958-6.958c0-3.844 3.115-6.964 6.958-6.964s6.958 3.12 6.958 6.964z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/brand/cib-asana.js
// module id = null
// module chunks = 